import styled from 'styled-components/macro'

export const Bar = styled.a`
  widtch: 100%;
  display: block;
  background: black;
  padding: 24px;
  color: white;
  cursor pointer;
  font-sie: 16px;
  display:flex;
  justify-content: flex-start;
  
  &:hover {
      color: white;
      text-decoration: underline;
      .icon {
        padding-right:16px;
        svg {
            font-size:16px;
        }
    }
  }



  .icon {
      padding-right:12px;
  }
`
